import * as React from 'react';

import { Divider, Grid2 as Grid, styled } from '@mui/material';

import { NavigationLinks } from '@mewa/types';
import { ResponsiveGrid } from '@mewa/ui';

import t from '../../../libs/translate';
import {
  CardAssets,
  HeaderAndFooterTranslations,
  SearchPageTranslations,
  ServiceSegmentLink,
} from '../../components/header/types';
import { AllCategoriesSliders } from '../../components/slider/all-categories-sliders';

const SearchNoResultsSlider = ({
  data,
  langPrefix,
  translations,
}: {
  data: {
    clothingServiceSegments: (ServiceSegmentLink & CardAssets)[];
    nonClothingServiceSegments: (ServiceSegmentLink & CardAssets)[];
    navigationLinks: NavigationLinks;
    headerAndFooterTranslations: HeaderAndFooterTranslations;
  };
  langPrefix: string;
  translations: SearchPageTranslations;
}) => {
  return (
    <>
      <ResponsiveGrid>
        <Grid size={12}>
          <CustomDivider />
          <SectionTitle>
            {t(translations, 'search_page_no_results_recommendations')}
          </SectionTitle>
        </Grid>
      </ResponsiveGrid>
      <AllCategoriesSliders
        clothingServiceSegments={data.clothingServiceSegments}
        nonClothingServiceSegments={data.nonClothingServiceSegments}
        langPrefix={langPrefix}
        headerAndFooterTranslations={data.headerAndFooterTranslations}
        navigationLinks={data.navigationLinks}
      />
    </>
  );
};

const CustomDivider = styled(Divider)(() => ({
  backgroundColor: 'var(--color-dark-coal)',
  height: '1px',
  width: '100%',
}));

const SectionTitle = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  fontWeight: theme.typography.fontWeightMedium,
  marginBottom: '30px',

  [theme.breakpoints.up('sm')]: {
    marginBottom: '50px',
  },
}));

export default SearchNoResultsSlider;
